import { isHTMLElement } from './is-html-element';
export function getElementId(element) {
  if (!isHTMLElement(element)) {
    return undefined;
  }
  return element.id || element.dataset.id || element.dataset.testId;
}